import { Tooltip, withStyles } from '@material-ui/core';

// export default function ToolTip() {
//     return (
//         <div>
            
//         </div>
//     )
// }

export default withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#104E84'
    },
    arrow: {
      color: '#104E84'
    }
  }))(Tooltip);